import { phone } from './VuelidateCustomValidatoins'
import { gregorian_to_jalali, jalali_to_gregorian } from './jalali'

export const pad = (num, size) => {
    let s = num + ''
    while (s.length < size) s = '0' + s
    return s
}

export const changeFormShapeIfItIsPhone = (form) => {
    if (phone(form.email)) {
        form = { ...form, cellphone: form.email }
        delete form.email
        return form
    }
    return form
};
export const checkDuplicate = (items, newItem) => {
    return items.indexOf(newItem);
}

export const convertToJalali = (date, separator = '/') => {
    let convertToDateObject = new Date(date)
    return gregorian_to_jalali(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator)
};

export const convertToGregory = (date, separator = '/') => {
    let convertToDateObject = new Date(date)
    return jalali_to_gregorian(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator)
};

export const convertToGregoryWithTime = (date, separator = '-') => {
    let convertToDateObject = new Date(date)
    return jalali_to_gregorian(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator) + ' ' + pad(convertToDateObject.getHours(), 2) + ':' + pad(convertToDateObject.getMinutes(), 2) + ':' + pad(convertToDateObject.getSeconds(), 2)
};

export const convertToJalaliWithTime = (date, separator = '-') => {
    let convertToDateObject = new Date(date)
    return gregorian_to_jalali(convertToDateObject.getFullYear(), convertToDateObject.getMonth() + 1, convertToDateObject.getDate()).join(separator) + ' ' + pad(convertToDateObject.getHours(), 2) + ':' + pad(convertToDateObject.getMinutes(), 2) + ':' + pad(convertToDateObject.getSeconds(), 2)
};

export const dateConverter = (date, separator = '/', time = false, to = 'jalali') => {
    if (to === 'jalali') {
        if (time) {
            return convertToJalaliWithTime(date,separator)
        }
        return convertToJalali(date,separator)
    }
    if (to === 'gregory') {
        if (time) {
            return convertToGregoryWithTime(date,separator)
        }
        return convertToGregory(date,separator)
    }
    return date
}

export const removeBlankAttributes = (data) => {
    return Object.fromEntries(Object.entries(data).filter(([_, v]) => v !== ""))
}

export const findObjects = (items, item) => {
    let result = null
    items.filter(i => {
        if (i.name === item) {
            result = i
        }
    })
    return result

}


export const findObjectIndex = (items, item) => {
    let result = null
    items.filter((i, index) => {
        if (i.id === item.id) {
            result = index
        }
    })
    return result
}

export const formatNumber = (Number) => {
    if (Number == undefined)
        return 0

    return parseInt(Number).toLocaleString("fa-IR")
}
